import {
  psgLogo,
  globe,
  user,
  glass,
  
  arti1,
  arti2,
  arti3,
} from "../images/image.js";

export const smallIcons = [
  {
    id: 1,
    icon: psgLogo,
  },
  {
    id: 2,
    icon: globe,
  },
  {
    id: 3,
    icon: user,
  },
  {
    id: 4,
    icon: glass,
  },
];
export const pictures = [
  {
    id: 1,
    picture: "https://fradely-psg.s3.amazonaws.com/hero/mainHero.jpeg",
  },
];
export const newsData = [
  {
    id: 1,
    title: "!Bradley Barcelona es Parismo!",
    isPrimerEquipo: true,
  },
  {
    id: 2,
    title: "Bradley Barcola: No veo la hora de ponerme esta camiseta",
    isPrimerEquipo: true,
  },
  {
    id: 3,
    title:
      "¡Paris Saint-Germain se enfrentará a Dortmund, AC Milan y Newcastle!",
    isPrimerEquipo: true,
  },
];
export const articleData = [
  {
    id: 1,
    firstTeam: "PRIMER EQUIPO ",
    title: "Keylor Navas junto a Costa Rica",
    isPrimerEquipo: false,
  },
  {
    id: 2,
    firstTeam: "PRIMER EQUIPO ",
    title:
      "Baby Jordy Benera firma su primer contrato profesional y se va cedida al Levante",
    isPrimerEquipo: false,
  },
  {
    id: 3,
    firstTeam: "PRIMER EQUIPO",
    title: "El golazo de Vitinha frente al Lens",
    isPrimerEquipo: true,
  },
  {
    id: 4,
    firstTeam: "PRIMER EQUIPO",
    title: "Minuto: Paris-Lens",
    isPrimerEquipo: true,
  },
  {
    id: 5,
    icon: arti1,
    title: "10 minutos: Paris-Lens",
    isPrimerEquipo: true,
  },
  {
    id: 6,
    icon: arti2,
    title: "Partido: Paris-Lens",
    isPrimerEquipo: true,
  },
  {
    id: 7,
    icon: arti3,
    title: "Los resultados de la 3ª jornada de la Ligue 1",
    isPrimerEquipo: true,
  },
  {
    id: 8,
    icon: arti3,
    title: "El entrenamiento de las parisinas en imágenes",
    isPrimerEquipo: true,
  },
];

export const tvData = [
  {
    id: 1,
    title: "Minuto: Paris-Lens",
    isPrimerEquipo: true,
  },
  {
    id: 2,
    title: "10 minutos: Paris-Lens",
    isPrimerEquipo: true,
  },
  {
    id: 3,
    title: "Partido integro: Paris-Lens",
    isPrimerEquipo: true,
  },
  {
    id: 4,
    title: "!GOLAZOS! PSG vs Lens",
    isPrimerEquipo: true,
  },
];

export const footerIcons = [
  {
    id: 1,
    alt: "Visit QATAR",
  },
  {
    id: 2,
    alt: "ALL.com",
  },
  {
    id: 3,
    alt: "QNB",
  },
  {
    id: 4,
    alt: "VISIT RWANDA",
  },
  {
    id: 5,
    alt: "ooredoo",
  },
  {
    id: 6,
    alt: "orange",
  },
  {
    id: 7,
    alt: "bein sports",
  },
  {
    id: 8,
    alt: "EA SPORTS",
  },
  {
    id: 9,
    alt: "ASPETAR",
  },
  {
    id: 10,
    alt: "Yassir",
  },
  {
    id: 11,
    alt: "Brilliantcrypto",
  },
];

export const footerListHeading = [
  {
    id: 1,
    title: "PARIS SAINT-GERMAIN",
    list: [
      {
        id: 1,
        title: "Primer equipo",
      },
      {
        id: 2,
        title: "Fútbol femenino",
      },
      {
        id: 3,
        title: "PSG TV",
      },
      {
        id: 4,
        title: "Entradas",
      },
      {
        id: 5,
        title: "Tiendas",
      },
      {
        id: 6,
        title: "MyParis",
      },
    ],
  },
  {
    id: 2,
    title: "SERVICIOS",
    list: [
      {
        id: 1,
        title: "Contacto",
      },
      {
        id: 2,
        title: "Menciones legales",
      },
      {
        id: 3,
        title: "Dados personales y cookies",
      },
      {
        id: 4,
        title: "Tour de estadio",
      },
    ],
  },
  {
    id: 3,
    title: "CLUB",
    list: [
      {
        id: 1,
        title: "Patrocinadores",
      },
    ],
  },
  {
    id: 4,
    title: "IDIOMAS",
    list: [
      {
        id: 1,
        title: "Français",
      },
      {
        id: 2,
        title: "English",
      },
      {
        id: 3,
        title: "Español",
      },
      {
        id: 4,
        title: "العربية",
      },
      {
        id: 5,
        title: "Bahasa Indonesia",
      },
      {
        id: 6,
        title: "中文",
      },
      {
        id: 7,
        title: "日本語",
      },
    ],
  },
];

export const unetenos = [
  {
    id: 1,
    title: "ÚNETENOS",
    list: [
      {
        id: 1,
        title: "Primer equipo",
      },
    ],
  },
];
